import React from "react";

const Spinner = ({ label = "Loading" }) => (
  <div
    className="flex flex-col justify-center items-center w-full py-16 gap-4"
    role="status"
    aria-label={label}
  >
    <div className="relative w-10 h-10">
      <div className="absolute inset-0 rounded-full border-2 border-[#1E3A5F]/10" />
      <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-[#14B48C] animate-spin" />
    </div>
    <span className="text-sm text-[#607080] font-medium sr-only">{label}</span>
  </div>
);

export default Spinner;
